import api from './api'
import {
  AdminOrderListResponse,
  PaginationParams,
  OrderDetailResponse
} from '../types/api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

const adminOrderService = {
  async list(params?: {
    customer?: string
    dateFrom?: string
    dateTo?: string
    minValue?: number
    maxValue?: number
    status?: string
    shippingMethod?: string
    trackingCode?: string
    sortBy?: 'createdAt' | 'total' | 'status' | 'orderNumber' | 'customerName' | 'paymentMethod'
    sortOrder?: 'asc' | 'desc'
  } & PaginationParams): Promise<AdminOrderListResponse> {
    const response = await api.post<
      ApiSuccessResponse<AdminOrderListResponse>
    >('/admin/orders', params)

    return response.data.data
  },

  async getById(orderId: string): Promise<OrderDetailResponse> {
    const response = await api.get<ApiSuccessResponse<OrderDetailResponse>>(
      `/admin/orders/${orderId}`
    )

    return response.data.data
  },

  async getPendingCount(): Promise<number> {
    try {
      const response = await api.post<
        ApiSuccessResponse<AdminOrderListResponse>
      >('/admin/orders', {
        status: 'PENDING',
        page: 1,
        limit: 1
      })

      const data = response.data.data
      return data.pagination?.total ?? data.orders.length ?? 0
    } catch (error) {
      console.error('Erro ao buscar pedidos pendentes:', error)
      return 0
    }
  }
}

export default adminOrderService

